/**
 * @name: articleManagement.js
 * @description: 文章管理路由
 * @author: 杨波
 * @create: 2020/08/031 16:38:51
 * @update: 2020/08/31 16:38:51
 */

export default [
  {
    path: '/article/material/list',
    name: 'materialManagement',
    component: () => import('@/views/article/material/List'),
    meta: {
      title: '素材管理'
    }
  },
  {
    path: '/article/material/add',
    name: 'materialAdd',
    component: () => import('@/views/article/material/Add'),
    meta: {
      title: '添加素材',
      parentRoutePath: 'materialManagement'
    }
  },
  {
    path: '/article/content/list',
    name: 'contentManagement',
    component: () => import('@/views/article/content/List'),
    meta: {
      title: '内容管理'
    }
  },
  {
    path: '/article/content/add',
    name: 'contentAdd',
    component: () => import('@/views/article/content/Add'),
    meta: {
      title: '添加内容',
      parentRoutePath: 'contentManagement'
    }
  },
  {
    path: '/article/article/list',
    name: 'articleManagement',
    component: () => import('@/views/article/article/List'),
    meta: {
      title: '系统管理文章'
    }
  },
  {
    path: '/article/article/add',
    name: 'articleAdd',
    component: () => import('@/views/article/article/Add'),
    meta: {
      title: '添加系统管理文章',
      parentRoutePath: 'articleManagement'
    }
  }
];
